import React from 'react'
import PersonalizedServiceForm from '@components/PersonalizedServiceForm'

const PersonalizedService = ({ dictionary, lang }) => {
    return (
        <section className='px-3 mt-5 2xl:w-8/12 mx-auto'>
            <PersonalizedServiceForm dictionary={dictionary.sellForm} lang={lang} />
        </section>
    )
}

export default PersonalizedService